// pub / sub through Vue
window.Event = new Vue();



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/shared/vue/events.js